<template>
    <div class="betslip-footer">
        <BinarySwitcher
            class="betslip-footer__binary-switcher"
            v-bind="switcherOptions"
            @change="onTypeClick"
            :value="value"
        />
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import BinarySwitcher from '@shared/components/BinarySwitcher.vue';
    import { BetSlipPurchaseType } from '@core/models/shared/betSlip/betSlipEnums';
    import { upperCase } from '@modules/shared/filters';
    import Modals from '@store/modules/ui/shared/modal/modals';


    export default {
        name: 'BetSlipFooter',
        props: {
            isOnline: {
                type: Boolean,
                required: true,
            },
            isLoggedIn: {
                type: Boolean,
                required: true,
            },
        },
        data() {
            return {
                switcherOptions: null,

            };
        },
        created() {
            this.switcherOptions = {
                first: {
                    label: upperCase(this.$t('online')),
                    value: BetSlipPurchaseType.online,
                },
                second: {
                    label: upperCase(this.$t('agency')),
                    value: BetSlipPurchaseType.offline,
                }
            };
        },
        methods: {
            ...mapActions('ui/modal', [
                'pushModal',
            ]),
            onTypeClick(type) {
                if (type === this.switcherOptions.first.value && !this.isLoggedIn) {
                    this.clickedOnline = true;
                    this.pushModal({
                        code: Modals.login.code,
                        goBack: true,
                    });
                } else {
                    this.$emit('typeClick', type);
                }
            },
        },
        computed: {
            value() {
                return this.isOnline ? this.switcherOptions.first.value : this.switcherOptions.second.value;
            },
        },
        watch: {
            isLoggedIn(newValue) {
                if (newValue && this.clickedOnline) {
                    this.$emit('typeClick', this.switcherOptions.first.value);
                    this.clickedOnline = false;
                }
            },
        },
        components: {
            BinarySwitcher
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/shared/betSlip/BetSlipFooter.vue